import { ChangeDetectorRef, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AccountService, QuestionTemplateService } from '../../../../services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountExpanded, Kid, MinorExpanded, QuestionTemplate } from 'common/interfaces';
import { FieldValidator } from '../../../common/validator';
import { Router } from '@angular/router';
import { KidForm } from '../../forms';

@Component({
  selector: 'update-minors-modal',
  styleUrls: ['./update-minors-modal.component.scss'],
  templateUrl: './update-minors-modal.component.pug'
})
export class UpdateMinorsModal {
  @ViewChildren(KidForm) public minorForms: QueryList<KidForm>;
  @Output() public onSubmit: EventEmitter<any> = new EventEmitter();

  @Input() public account: AccountExpanded;
  @Input() public filterType: number = 0;
  public registration: any;
  public screeningId: number;
  public registrationId: number;
  public form: FormGroup;
  public childCount: number;
  public isChildValid: boolean;
  public loaded: boolean = false;
  public children = Array<Kid>();
  private isValid = false;
  public childTemplates: Array<QuestionTemplate> = [];
  public childrenOptions: Array<number>;
  public showUpdateSuccessAlert: boolean;
  public showUpdateErrorAlert: boolean;
  public updateErrorMessage: string;
  public updateSuccessMessage: string;
  public waiting: boolean = false;

  public parentOptions: Object[] = [
    {
      label: 'Yes',
      value: true
    },
    {
      label: 'No',
      value: false
    }
  ];

  constructor(private questionTemplateService: QuestionTemplateService, private accountService: AccountService, private router: Router, public dialog: BsModalRef, public formBuilder: FormBuilder, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.questionTemplateService.get(this.filterType).subscribe(
      templates => {
        this.childTemplates = templates.filter(qt => qt.isForMinor)
      },
      err => console.log('QuestionTemplate error - ', err)
    );

    this.form = this.getUpdatedFormGroup();
    this.form.valueChanges.subscribe(data => this.checkValidationState());
    this.loaded = true;
    this.checkValidationState();
    this.childrenOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  }

  public getUpdatedFormGroup() {
    if (!this.account) {
      this.account = {};
    }
    if (this.account.isParent) {
      this.childCount = this.account.Minors?.length || 1 //must have 1 child if parent
      this.onChildCountChanged(this.childCount, this.account.Minors)
    }
    return this.newGroup();
  }

  public newGroup() {
    const formGroup = this.formBuilder.group({

      email: [this.account.email, FieldValidator.emailFormat],
      isParent: [this.account.isParent, Validators.required]
    });
    formGroup.controls.isParent.valueChanges.subscribe(data => this.cdr.detectChanges())
    formGroup.controls.isParent.valueChanges.subscribe(data => this.isParentChanged(data))
    return formGroup;
  }

  private isParentChanged(isParent) {
    this.account.isParent = !!(typeof isParent?.value === 'boolean' ? isParent.value : isParent)
    if (this.account.isParent) {
      this.childCount = this.account.Minors?.length || 1 //must have 1 child if parent
      this.onChildCountChanged(this.childCount, this.account.Minors)
    } else {
      this.childCount = 0
      this.onChildCountChanged(this.childCount, this.account.Minors)
    }
  }

  public onChildCountChanged(childCount: number, childData: MinorExpanded[] = []) {
    if (childCount < 1) {
      this.isChildValid = true;
    }
    if (isNaN(childCount)) {
      return;
    }
    this.children = childData.filter((x, i) => i < childCount);;
    if (this.children.length < childCount) {
      this.children.push(...(new Array(childCount - this.children.length).fill({})))
    }
    this.cdr.detectChanges();
  }

  // this will emit any time state changes
  private checkValidationState() {
    if (this.form.valid !== this.isValid) {
      this.isValid = this.form.valid;
    }
  }

  public valid() {
    const minorValid = (this.minorForms ? this.minorForms.reduce((p, c) => (p && c.valid()), true) : true);
    return this.form ? this.form.valid && minorValid : minorValid;
  }

  public onKeyUp() {
    this.close();
  }

  public onConfirm() {
    if (this.account.isParent) {
      this.waiting = true;
      const registrationData = {
        Account: {
          id: this.account.id,
          isParent: this.account.isParent
        },
        Children: this.minorForms.map(m => m.values()),
      }

      this.accountService.update(registrationData).subscribe(
        account => {
          account.Minors = account.Minors;
          this.accountService.currentUser.next(account);
          this.waiting = false;
          this.close()
        },
        err => {
          this.waiting = false;
          this.showUpdateErrorAlert = true;
          this.updateErrorMessage = err?.error?.error?.message ?? 'Could not update account info. Please try again later.';
        }
      );
    } else {
      this.close();
    }

  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialog.hide();
    this.onSubmit.emit();
  }
}
